"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VDOMTransform = exports.GIFTransform = exports.JPEGTransform = exports.PNGTransform = exports.SVGTransform = exports.LaTeXTransform = exports.MarkdownTransform = exports.HTMLTransform = exports.JavaScriptTransform = exports.JSONTransform = exports.TextTransform = exports.displayOrder = exports.transforms = exports.standardDisplayOrder = exports.standardTransforms = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.registerTransform = registerTransform;
exports.richestMimetype = richestMimetype;

var _text = require("./text.js");

var _text2 = _interopRequireDefault(_text);

var _json = require("./json.js");

var _json2 = _interopRequireDefault(_json);

var _javascript = require("./javascript.js");

var _javascript2 = _interopRequireDefault(_javascript);

var _html = require("./html.js");

var _html2 = _interopRequireDefault(_html);

var _markdown = require("./markdown.js");

var _markdown2 = _interopRequireDefault(_markdown);

var _latex = require("./latex.js");

var _latex2 = _interopRequireDefault(_latex);

var _svg = require("./svg.js");

var _svg2 = _interopRequireDefault(_svg);

var _image = require("./image.js");

var _transformVdom = require("@nteract/transform-vdom");

var _transformVdom2 = _interopRequireDefault(_transformVdom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var tfs = [_transformVdom2.default, _json2.default, _javascript2.default, _html2.default, _markdown2.default, _latex2.default, _svg2.default, _image.GIFDisplay, _image.PNGDisplay, _image.JPEGDisplay, _text2.default];

var standardTransforms = exports.standardTransforms = {};

tfs.forEach(function (transform) {
  standardTransforms[transform.MIMETYPE] = transform;
});

var standardDisplayOrder = exports.standardDisplayOrder = tfs.map(function (transform) {
  return transform.MIMETYPE;
});

function registerTransform(_ref, transform) {
  var transforms = _ref.transforms,
      displayOrder = _ref.displayOrder;

  return {
    transforms: _extends({}, transforms, _defineProperty({}, transform.MIMETYPE, transform)),
    displayOrder: [transform.MIMETYPE].concat(_toConsumableArray(displayOrder))
  };
}

/**
 * Choose the richest mimetype available based on the displayOrder and transforms
 * @param  {Map}   bundle - Map({mimetype1: data1, mimetype2: data2, ...})
 * @param  {Array} ordered list of mimetypes - ['text/html', 'text/plain']
 * @param  {Map}   mimetype -> React Component - Map({'text/plain': TextTransform})
 * @return {string}          Richest mimetype
 */

function richestMimetype(bundle) {
  var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : standardDisplayOrder;
  var tf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : standardTransforms;

  return [].concat(_toConsumableArray(Object.keys(bundle)))
  // we can only use those we have a transform for
  .filter(function (mimetype) {
    return tf[mimetype] && order.includes(mimetype);
  })
  // the richest is based on the order in displayOrder
  .sort(function (a, b) {
    return order.indexOf(a) - order.indexOf(b);
  })[0];
}
var transforms = exports.transforms = standardTransforms;
var displayOrder = exports.displayOrder = standardDisplayOrder;
var TextTransform = exports.TextTransform = _text2.default;
var JSONTransform = exports.JSONTransform = _json2.default;
var JavaScriptTransform = exports.JavaScriptTransform = _javascript2.default;
var HTMLTransform = exports.HTMLTransform = _html2.default;
var MarkdownTransform = exports.MarkdownTransform = _markdown2.default;
var LaTeXTransform = exports.LaTeXTransform = _latex2.default;
var SVGTransform = exports.SVGTransform = _svg2.default;
var PNGTransform = exports.PNGTransform = _image.PNGDisplay;
var JPEGTransform = exports.JPEGTransform = _image.JPEGDisplay;
var GIFTransform = exports.GIFTransform = _image.GIFDisplay;
var VDOMTransform = exports.VDOMTransform = _transformVdom2.default;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(tfs, "tfs", "src/index.js");
  reactHotLoader.register(standardTransforms, "standardTransforms", "src/index.js");
  reactHotLoader.register(standardDisplayOrder, "standardDisplayOrder", "src/index.js");
  reactHotLoader.register(registerTransform, "registerTransform", "src/index.js");
  reactHotLoader.register(richestMimetype, "richestMimetype", "src/index.js");
  reactHotLoader.register(transforms, "transforms", "src/index.js");
  reactHotLoader.register(displayOrder, "displayOrder", "src/index.js");
  reactHotLoader.register(TextTransform, "TextTransform", "src/index.js");
  reactHotLoader.register(JSONTransform, "JSONTransform", "src/index.js");
  reactHotLoader.register(JavaScriptTransform, "JavaScriptTransform", "src/index.js");
  reactHotLoader.register(HTMLTransform, "HTMLTransform", "src/index.js");
  reactHotLoader.register(MarkdownTransform, "MarkdownTransform", "src/index.js");
  reactHotLoader.register(LaTeXTransform, "LaTeXTransform", "src/index.js");
  reactHotLoader.register(SVGTransform, "SVGTransform", "src/index.js");
  reactHotLoader.register(PNGTransform, "PNGTransform", "src/index.js");
  reactHotLoader.register(JPEGTransform, "JPEGTransform", "src/index.js");
  reactHotLoader.register(GIFTransform, "GIFTransform", "src/index.js");
  reactHotLoader.register(VDOMTransform, "VDOMTransform", "src/index.js");
  leaveModule(module);
})();

;


//////////////////
// WEBPACK FOOTER
// ./~/@nteract/transforms/lib/index.js
// module id = 49
// module chunks = 186292428941015